import React, { ComponentType } from 'react';

import { II18nClient, ITranslateFn } from '@wix/podcasts-common/dist/i18n';

const { Provider: I18nProvider, Consumer: I18nConsumer } =
  React.createContext<II18nClient>(null);

interface IWithI18nProps {
  t: ITranslateFn;
  locale: string;
}

function withI18n<P extends IWithI18nProps>(
  Component: ComponentType<P>,
): ComponentType<Omit<P, keyof IWithI18nProps>> {
  return function ComponentWithI18n(props) {
    return (
      <I18nConsumer>
        {(i18n) => (
          <Component
            {...(props as any)}
            locale={i18n.locale}
            t={i18n.translate}
          />
        )}
      </I18nConsumer>
    );
  };
}

export { I18nProvider, I18nConsumer, withI18n, IWithI18nProps };
